import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type toolsPermissionType = 'tools_view';

export const toolsPermissionMatrix: IPermissionMatrix<toolsPermissionType> = {
  tools_view: [UserRole.user]
};
